import React from "react";
import "./loading.scss";
import LTMLogo from "../../../images/LTM.png";

const Loading = () => {
  return (
    <div className="loading">
      <div className="loading-container">
        <div className="loading-circle">
          {/* Rotating sparkles */}
          <div className="sparkle sparkle-1">★</div>
          <div className="sparkle sparkle-2">★</div>
          <div className="sparkle sparkle-3">★</div>
          <div className="sparkle sparkle-4">★</div>
          
          {/* Logo */}
          <img src={LTMLogo} alt="LTM Logo" className="loading-logo" />
        </div>
        <div className="loading-text">LOADING ...</div>
      </div>
    </div>
  );
};

export default Loading;
